import React from 'react';
import { AccessDenied, PageNotFound } from '@/layout/common-pages';
import { ROUTES } from '@/constants/routes';

/**
 * Public routes configuration (no authentication required)
 */
export const publicRoutes = [
  {
    path: ROUTES.UNAUTHORIZED,
    element: <AccessDenied />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <PageNotFound />,
  },
];
